let getCookie = function (key) {
  let cookie = document.cookie.split(";");
  for (let i of cookie) {
    let cookie_key = i.split("=")[0].trim();
    if (key == cookie_key) {
      return i.split("=")[1];
    }
  }
  return null;
};
let setCookie = function (key, value) {
  document.cookie = ` ${key}=${value};Domain=${document.domain}`;
};

let dateFormat = function (timestamp) {
  let date = new Date(timestamp);
  return `${date.getFullYear()}-${date.getMonth() +
    1}-${date.getDate()} ${date.getHours()}:${
    date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()
    }`;
};
/**
 * get index by item or case's object_id in target Array
 * @param {Array} arr -target array
 * @param {String} oid -object_id
 * @returns {Number} index
 */
var indexQuery = function (arr, oid) {
  for (let i in arr) {
    if (arr[i]["o_id"] == oid) {
      return Number(i);
    }
  }
};
/**
 * get case by case name
 * @param {Array} arr -all cases
 * @param {string} name - case name 
 * @returns {Number} index of the case
 */
var findCaseByName = function (arr, name) {
  for (let i in arr) {
    if (arr[i]["caseName"] == name) {
      return i;
    }
  }
};
/**
 * deep clone
 * @param {*} data 
 */
var deepClone = function (data) {
  let o, i, ni;
  if (data instanceof Array) {
    o = [];
  } else if (data instanceof Object) {
    o = {};
  } else {
    return data;
  }

  if (data instanceof Array) {
    for (i = 0, ni = data.length; i < ni; i++) {
      o.push(deepClone(data[i]));
    }
    return o;
  } else if (data instanceof Object) {
    for (i in data) {
      o[i] = deepClone(data[i]);
    }
    return o;
  }
};
export default {
  getCookie,
  setCookie,
  dateFormat,
  indexQuery,
  findCaseByName,
  deepClone
};



// WEBPACK FOOTER //
// ./src/util.js